// Minimal process shim for the sandboxed Electron renderer / web builds.
// Prevents "process is not defined" from packages that check process.env or
// process.platform at module-initialisation time.
const process = {
  env:      {},
  platform: 'web',
  version:  '',
  browser:  true,
  nextTick: (fn, ...args) => setTimeout(() => fn(...args), 0),
};

module.exports = process;
